<template lang="">
	<div class="search-option-wrapper">		
        <span>{{ label }}</span>
		<div class="search-option-wrapper__normal">
			<el-input :placeholder="placeholder" :value="value" @input="onchange"/>
		</div>
	</div>
</template>

<script>
export default {
	props: ['label', 'placeholder', 'value', 'onchange']
    , methods: {
		// printStatus: printStatus
	}	
};
</script>
<style lang=""></style>